<template>
  <BaseDialog
    :title="$t('lumia.lesson.feedback.linkTitle')"
    type="basic"
    :is-open="isOpen"
    class="w-full max-w-md"
    @close="emit('close')"
  >
    <LessonPortalLink
      v-for="team in teams"
      :key="team.id"
      :team-id="team.id"
      :team-name="team.name"
      :show-name="teams.length > 1"
    />
    <template #dismiss>
      <BaseTextButton @click="emit('close')">{{ $t('common.close') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import LessonPortalLink from './LessonPortalLink.vue'

  defineProps<{
    isOpen: boolean
    teams: ReadonlyArray<{
      readonly id: string
      readonly name: string
    }>
  }>()

  const emit = defineEmits<{
    close: []
  }>()
</script>
